var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlusNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.059,
    cy: 12,
    r: 12,
    fill: "#E9F8F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00A082",
    d: "M12.059 6.2a1 1 0 01.993.884l.007.116V11h3.8a1 1 0 01.993.884l.007.116a1 1 0 01-.884.993L16.86 13h-3.8v3.8a1 1 0 01-.884.994l-.116.006a1 1 0 01-.993-.883l-.007-.117V13h-3.8a1 1 0 01-.993-.883L6.259 12a1 1 0 01.883-.993L7.26 11h3.8V7.2a1 1 0 01.883-.993l.117-.007z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusNew);
export default __webpack_public_path__ + "static/media/plusNew.cb2ed2cd09e67f2d2d54d6cb35b002b9.svg";
export { ForwardRef as ReactComponent };